/**
 * LiveKit client config. Server URL for browser connection.
 * CRA exposes REACT_APP_* only; fallback to LIVEKIT_WS_URL if injected at build.
 */
export const livekitConfig = {
  serverUrl:
    process.env.REACT_APP_LIVEKIT_WS_URL ||
    process.env.LIVEKIT_WS_URL ||
    '',
};
